import React, { useState, useEffect } from "react";
import { Card, Button } from "react-bootstrap";
import ReactQuill from "react-quill"; // Assuming you have ReactQuill installed
import "react-quill/dist/quill.snow.css";
import { getDataApi, putDataApi } from "../../../utility/apiCalling";
import { URLs } from "../../../utility/constants";
import { useSelector } from "react-redux";
import { toastMsgSuccess, toastMsgError } from "../../../utility/constants";
import { ToastContainer } from "react-toastify";

export default function Privacy_policy() {
  const state = useSelector((state) => state);
  const [pageOffset, setPageOffset] = useState(0);
  const [bodyText, setBodyText] = useState(""); // State

  const fetchData = async () => {
    try {
      let res = await getDataApi(
        `${URLs.privacyGetURL}?offset=${pageOffset}&limit=10`,
        state.auth.authToken
      );

      if (res.status === 200) {
        // console.log(res);
        // console.log(res.data.data.description);

        let res_data = res.data.data.description;
        setBodyText(res_data); // Assuming the response contains a bodyText field
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handlePost = async () => {
    try {
      let item = {
        description: bodyText,
      };

      let res = await putDataApi(
        URLs.privacyPutURL,
        state.auth.authToken,
        item
      );
      console.log("Posting:", res);
      console.log("Data posted successfully");
      console.log("Response:", res);

      if (res.status === 200) {
        fetchData();
        console.log("Data posted successfully");
        toastMsgSuccess("Successfully Added!");
      } else {
        console.log("Error message:", res.message);
        toastMsgError(res.message);
      }
    } catch (error) {
      console.error("Error posting data:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  // const [bodyText, setBodyText] = useState(""); // State to hold the content
  // const [privacypolicybodyText, setprivacypolicybodyText] = useState(""); // State to hold the content

  // useEffect(() => {
  //   // Load bodyText from local storage when component mounts
  //   const storedprivacytermconBodyText = localStorage.getItem(
  //     "privacypolicybodyText"
  //   );
  //   if (storedprivacytermconBodyText) {
  //     setprivacypolicybodyText(storedprivacytermconBodyText);
  //   }
  // }, []);

  // const handlePost = () => {
  //   // Logic to post the content (e.g., save it to a database)
  //   console.log("Posting:", privacypolicybodyText);
  //   toastMsgSuccess("Successfully Added!");
  //   // Save bodyText to local storage
  //   localStorage.setItem("privacypolicybodyText", privacypolicybodyText);
  // };

  return (
    <div>
      <Card>
        <div>
          <ReactQuill
            theme="snow"
            placeholder="Write something..."
            modules={Privacy_policy.modules}
            formats={Privacy_policy.formats}
            value={bodyText}
            onChange={(text) => setBodyText(text)}
            // value={privacypolicybodyText}
            // onChange={(text) => setprivacypolicybodyText(text)}
          />
        </div>

        <Button
          variant="success"
          style={{ width: "100px", marginTop: "50px", marginLeft: "45%" }}
          onClick={handlePost}
        >
          Submit
        </Button>
      </Card>
    </div>
  );
}

Privacy_policy.modules = {
  toolbar: [
    [{ header: [1, 2, false] }],
    ["bold", "italic", "underline", "strike", "blockquote"],
    [{ list: "ordered" }, { list: "bullet" }],
    ["link", "image"],
    [{ color: [] }],
  ],
};
Privacy_policy.formats = [
  "header",
  "bold",
  "italic",
  "underline",
  "strike",
  "blockquote",
  "list",
  "bullet",
  "indent",
  "link",
  "image",
  "color",
];
